import { userAgentIsHlApp } from '@/models/hl-app/user-agent'

/**
 * @see https://my-color.esa.io/posts/1362
 */
export class HlAppMode {
  static isPageForHlApp = window.gpHlAppContext && window.gpHlAppContext.isPageForHlApp
  static isViewedInHlAppWebView = userAgentIsHlApp(window.navigator.userAgent)
}
